import React from "react";
import { Modal, Pressable, Text, View } from "react-native";
import CheckGreen from "../../assets/svg/CheckMultiLayer";
import CrossIcon from "../../assets/svg/CrossIcon";
import Button from "../../components/Button";

const SuccessModal = ({
  showSuccessModal,
  setShowSuccessModal,
  goBack = () => {},
}) => {
  const onClose = () => {
    setShowSuccessModal(false);
    goBack();
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={showSuccessModal}
      onRequestClose={onClose}
    >
      <View>
        <Pressable
          onPress={onClose}
          style={{ paddingHorizontal: 15, paddingVertical: 20 }}
        >
          <CrossIcon height={28} width={28} />
        </Pressable>
      </View>
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CheckGreen />
        <Text
          style={{
            fontSize: 24,
            marginVertical: 10,
            fontFamily: "NotoSansDevanagari-Bold",
          }}
        >
          धन्यवाद् !
        </Text>
        <Text
          style={{ fontFamily: "NotoSansDevanagari-Regular", fontSize: 16 }}
        >
          आपके डाक्यूमेंट्स वेरिफिकेशन के लिए सबमिट हो गए है
        </Text>
        <Button
          btnText="Okay"
          buttonStyle={{ marginTop: 40, height: undefined }}
          borderRadius={10}
          onPress={onClose}
        />
      </View>
    </Modal>
  );
};

export default SuccessModal;
